import request from '@hotmart/request'

import { REQUEST_SECURITY } from 'modules/auth/auth.constants'
import { TOS_REQUEST_IDENTIFIERS } from 'modules/tos'
import { ITosFeature } from './preroutes.interface'

export const addSignupRole = (userId: string): Promise<void> => request(REQUEST_SECURITY.ADD_SIGNUP_ROLE, { userId })

export const getTosFeature = (): Promise<ITosFeature> => request(TOS_REQUEST_IDENTIFIERS.FEATURES)
